import script from "./TaxFreeLumpSumDescriber.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaxFreeLumpSumDescriber.vue?vue&type=script&setup=true&lang=ts"

import "./TaxFreeLumpSumDescriber.vue?vue&type=style&index=0&id=68c9c70a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68c9c70a"]])

export default __exports__